import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react'
import { ActionSheet } from 'types/types'

interface WalletActionProviderProps {
  children: ReactNode
}

export const WalletActionContext = createContext<
  [ActionSheet | null, React.Dispatch<React.SetStateAction<ActionSheet | null>>] | null
>(null)

export const WalletActionProvider = ({ children }: WalletActionProviderProps) => {
  const [walletAction, setWalletAction] = useState<ActionSheet | null>(null)

  const contextValue = useMemo(
    () =>
      [walletAction, setWalletAction] as [
        ActionSheet | null,
        React.Dispatch<React.SetStateAction<ActionSheet | null>>,
      ],
    [walletAction]
  )

  return (
    <WalletActionContext.Provider value={contextValue}>{children}</WalletActionContext.Provider>
  )
}

export const useWalletActionContext = () => {
  const context = useContext(WalletActionContext)

  return context
}
